import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ApexTable } from 'apex-table-ts';
import isNumber from 'lodash/isNumber';
import { FormattedMessage } from 'react-intl';

import DropdownMenu from 'components/DropdownMenu';
import Spinner from 'components/Spinner';
import { loadState, saveState } from 'utils/localStorage';
import { LOCAL_STORAGE_COLUMNS_KEY, MAX_COLUMN_WIDTH, MIN_COLUMN_WIDTH, SEARCH_RESULTS_COLUMNS } from './constants';
import styles from './styles.css';
import messages from './messages';

class SearchResultsTable extends Component {

  static propTypes = {
    height: PropTypes.number,
    intl: PropTypes.object.isRequired,
    rows: PropTypes.arrayOf(PropTypes.object),
    width: PropTypes.number,
    loading: PropTypes.bool.isRequired,
    onFilteredRowCountChange: PropTypes.func.isRequired,
    enableCsvExport: PropTypes.bool,
    showAllFields: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    height: -1,
    rows: [],
    width: -1,
    enableCsvExport: true,
  };

  static isValidColumnWidth(width) {
    return isNumber(width) && width >= MIN_COLUMN_WIDTH && width <= MAX_COLUMN_WIDTH;
  }

  static loadColumns(formatter, showAllFields) {
    const state = loadState(LOCAL_STORAGE_COLUMNS_KEY) || {};
    const columns = { ...SEARCH_RESULTS_COLUMNS };

    Object.keys(columns).forEach((key) => {
      if (key in messages) {
        columns[key].label = formatter(messages[key]);
        if (columns[key].externalPermissionsRequired && !showAllFields) {
          columns[key].isVisible = false;
        }
      }

      const col = state[key] || {};
      if ('width' in col && SearchResultsTable.isValidColumnWidth(col.width)) {
        columns[key].width = col.width;
      }
    });

    return columns;
  }

  static saveColumns(columns) {
    const state = {};

    Object.keys(columns).forEach((key) => {
      const col = columns[key] || {};
      if ('width' in col && SearchResultsTable.isValidColumnWidth(col.width)) {
        state[key] = { width: col.width };
      }
    });

    saveState(LOCAL_STORAGE_COLUMNS_KEY, state);
  }


  constructor(props) {
    super(props);

    this.state = {
      columns: SearchResultsTable.loadColumns(this.props.intl.formatMessage, this.props.showAllFields),
    };

    this.handleColumnResize = this.handleColumnResize.bind(this);
    this.handleFilteredRowsChange = this.handleFilteredRowsChange.bind(this);
  }

  handleColumnResize(key, width) {
    const { columns } = this.state;
    columns[key].width = width;
    SearchResultsTable.saveColumns(columns);
    this.setState({ columns });
  }

  handleFilteredRowsChange(rows) {
    this.props.onFilteredRowCountChange(rows.length);
  }

  render() {
    const {
      rows,
      height,
      width,
      loading,
      enableCsvExport,
    } = this.props;

    if (loading) {
      return <Spinner />;
    }

    if (rows.length < 1) {
      return (<p className={styles.emptySearchResults} data-test-handle="emptySearch"><FormattedMessage {...messages.emptySearchResults} /></p>);
    }

    return (
      <ApexTable
        columns={this.state.columns}
        defaultSortColumn="cumulativeAdjustedScore"
        defaultSortAscending={false}
        enableColumnResize
        enableClearFilters
        isLoading={false}
        maxColumnWidth={MAX_COLUMN_WIDTH}
        minColumnWidth={MIN_COLUMN_WIDTH}
        onColumnResized={this.handleColumnResize}
        onFilteredRowsChange={this.handleFilteredRowsChange}
        rows={rows}
        height={height}
        width={width}
        showHideColumns={{
          localStorageNamespace: LOCAL_STORAGE_COLUMNS_KEY,
          menuWrapper: DropdownMenu,
        }}
        csvLinkText={<FormattedMessage {...messages.exportToCsv} />}
        csvFilename="sentinel2-search-results.csv"
        enableCsvExport={enableCsvExport}
      />
    );
  }
}

export default SearchResultsTable;



// WEBPACK FOOTER //
// ./src/components/SearchResultsTable/index.js